import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { Logger } from '@saviynt/common';

import { useLocalize } from '../../../shared/hooks';
import { type ColumnPickerState } from '../../ViolationsTab/data-layer/violationsTabTypes';
import { violationsReportActions } from '../data-store/violationsReportSlice';

const useReportColumnsPicker = (reportType: string) => {
  const localize = useLocalize();
  const dispatch = useDispatch();

  const [fetchReportColumns] =
    violationsReportActions.useLazyGetReportColumnsQuery();

  const initializeReportColumns = useCallback(async () => {
    try {
      dispatch(
        violationsReportActions.setReportError({ state: false, reason: '' })
      );
      dispatch(violationsReportActions.setIsLoading(true));
      const response = (await fetchReportColumns(
        reportType.toUpperCase()
      ).unwrap()) as Record<string, ColumnPickerState[]>;

      const columnsList: ColumnPickerState[] = Object.values(response).flat();

      const modifiedColumnsList = columnsList.map((column) => ({
        label: localize(column.localizationKey),
        value: column.id,
        isChecked: column.isDefault,
        isDisabled: false,
      }));

      dispatch(violationsReportActions.setReportColumns(modifiedColumnsList));
      dispatch(violationsReportActions.setIsLoading(false));

      return true;
    } catch (error) {
      Logger.log('Error fetching column picker:', error);
      dispatch(violationsReportActions.setIsLoading(false));

      return false;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- should be only one time for `defaultColumns`
  }, [fetchReportColumns, localize, reportType, dispatch]);

  return { initializeReportColumns };
};

// eslint-disable-next-line import/prefer-default-export
export { useReportColumnsPicker };
